<template>
  <div>
    <h1>Dashboard</h1>
  </div>
</template>

<script setup></script>
